export const getBestCoach = () => {
  return [
    { value: 0, label: 'ندارد' },
    { value: 1, label: 'دارد' },
  ];
};

export const getTypes = [
  {
    value: 1,
    label: 'انفرادی',
  },
  {
    value: 2,
    label: 'تیمی',
  },
  {
    value: 3,
    label: 'لیگ',
  },
];
